"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8467],{

/***/ 78262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bc": function() { return /* binding */ trackingAnonymousId; },
/* harmony export */   "t8": function() { return /* binding */ LineEmptyEmailError; },
/* harmony export */   "yC": function() { return /* binding */ trackingUserId; }
/* harmony export */ });
var LineEmptyEmailError = "line_account_empty_email";
var trackingAnonymousId = "anonymous_id"; // used for segment
var trackingUserId = "user_id"; // used for segment


/***/ }),

/***/ 98373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ stripeProductFragment; },
/* harmony export */   "r": function() { return /* binding */ cartFragment; }
/* harmony export */ });
var stripeProductFragment = "\nfragment FStripeProduct on StripeProductDto {\n  uniqName\n  displayId\n  id\n  metadata\n  isShowOnShop\n  evaluationId\n  shopProductGroupIds\n  prices {\n    id\n    displayId\n    nickname\n  }\n}\n";
var cartFragment = "\nfragment FCart on CartDto {\n  sysId\n  status\n  cartItems {\n    teleConsultForSkipEval\n    completedEval\n    price {\n      active\n      id\n      unit_amount_decimal\n    }\n    consultationSessionType\n    product {\n      metadata\n      evaluationId\n      active\n      uniqName\n      id\n      image {\n        noahVertical\n        noahWide\n      }\n    }\n  }\n}";


/***/ }),

/***/ 90047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ CHECKOUT_ERROR; },
/* harmony export */   "hX": function() { return /* binding */ CHECKOUT_FORM_DATA; },
/* harmony export */   "u5": function() { return /* binding */ evaluationLSName; },
/* harmony export */   "uX": function() { return /* binding */ GUEST_NAME; }
/* harmony export */ });
/* unused harmony export GUEST_PATIENT_ID */
var GUEST_PATIENT_ID = "guest_patient_id";
var evaluationLSName = function(evalName) {
    return "evaluation_".concat(evalName);
};
var CHECKOUT_ERROR = "show_checkout_alert_msg";
var GUEST_NAME = "guest_name";
var CHECKOUT_FORM_DATA = "checkout_form_data";


/***/ }),

/***/ 26346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ TRACKING_EVENTS; },
/* harmony export */   "RJ": function() { return /* binding */ PAGE_VIEW_TRACKINGS; },
/* harmony export */   "er": function() { return /* binding */ TRACKING_EVENTS_2; },
/* harmony export */   "kl": function() { return /* binding */ PageEvents; },
/* harmony export */   "p$": function() { return /* binding */ getViewPageEventName; }
/* harmony export */ });
/* unused harmony export PRESCRIPTION_FLOW_REGEX */
/* harmony import */ var src_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3620);
/* harmony import */ var src_utils_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86229);
/* harmony import */ var _constants_url_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97479);



var PageEvents = {
    name: {
        logIn: "Log In",
        forgotPassword: "Forgot Password",
        signUp: "Sign Up",
        plans: "Plans",
        accountSettings: "Account Settings",
        orderHistory: "Order History",
        wallet: "Wallet",
        gettingStarted: "Getting Started - {eval_name}",
        healthProfile: "Health Profile - {eval_name} - Step {number}",
        whyAsk: "Why Ask This Question?",
        planDetails: "Plan Details",
        faqs: "FAQs",
        shippingFrequency: "Shipping Frequency",
        refillNow: "Refill Now",
        shippingInformation: "Shipping Information",
        billingInformation: "Billing Information",
        selectPreferredMedication: "Select Preferred Medication",
        medicationDetails: "Medication Details",
        preferenceDetails: "Preference Details",
        deliveryDetails: "Delivery Details",
        paymentDetails: "Payment Details",
        shopHome: "Shop Home",
        yourCart: "Your Cart",
        category: "Category - {category_name}"
    },
    categories: {
        logIn: "Log In",
        signUp: "Sign Up",
        dashboard: "Dashboard",
        account: "Account",
        plans: "Plans",
        evaluation: "Evaluation",
        healthProfile: "Health Profile",
        preferredMedication: "Preferred Medication",
        delivery: "Delivery",
        payment: "Payment",
        shop: "Shop",
        checkout: "Checkout"
    }
};
var TRACKING_EVENTS_2 = {
    signedIn: "Signed In",
    signedUp: "Signed Up",
    signedOut: "Signed Out",
    evaluationStarted: "Evaluation Started",
    evaluationUpdated: "Evaluation Updated",
    evaluationCompleted: "Evaluation Completed",
    productAdded: "Product Added",
    productRemoved: "Product Removed",
    couponApplied: "Coupon Applied",
    couponRemoved: "Coupon Removed",
    preferredMedicationSkipped: "Preferred Medication Skipped",
    checkoutStarted: "Checkout Started",
    checkoutCompleted: "Checkout Completed",
    paymentEntered: "Payment Info Entered",
    prescriptionRefillActivated: "Prescription Refill Activated",
    prescriptionRefillDeactivated: "Prescription Refill Deactivated",
    shippingFrequencyUpdated: "Shipping Frequency Updated",
    monthlyDoseUpdated: "Monthly Dose Updated",
    connectWithDoctorInitiated: "Connect With Doctor Initiated",
    profileDetailsUpdated: "Profile Details Updated",
    billingDetailsUpdated: "Billing Details Updated",
    shippingDetailsUpdated: "Shipping Details Updated",
    orderCompleted: "Order Completed",
    orderCancelled: "Order Cancelled",
    orderRefunded: "Order Refunded",
    doctorApproved: "Doctor Approved",
    doctorRejected: "Doctor Rejected"
};
var TRACKING_EVENTS = {
    LOGIN: "User logs in",
    ORDER_COMPLETED: "Order Completed",
    COMPLETE_REGISTRATION: "Complete Registration",
    EVALUATION: "Evaluation",
    VIEW_CHECKOUT_PAGE: "View Checkout Page",
    COMPLETE_PURCHASE: "Complete Purchase",
    ADD_ITEM_TO_CART: "Add Item To Cart",
    EDIT_SUBSCRIPTION: "Edit Subscription",
    VIEW_DETAIL: "View Item Detail Page",
    START_EVALUATION: "Start Evaluation",
    UPDATE_EVALUATION: "Update Evaluation",
    CONTINUE_EVALUATION: "Continue Evaluation",
    COMPLETE_EVAL: "Complete Evaluation",
    SEARCH: "Search",
    SKIP_MED: "Skip Med"
};
var PAGE_VIEW_TRACKINGS = {
    MEDS_SELECTION: "View Page: Start Meds Selection",
    VIEW_MEDS: "View Page: View Meds",
    TREATMENT_SUMMARY: "View Page: Treatment summary",
    SELECT_FREQUENCY: "View Page: Select Frequency",
    SELECT_DOSAGE: "View Page: Select Dosage",
    CONFIRM_ORDER: "View Page: Confirm Your Order",
    DELIVERY: "View Page: Delivery",
    PAYMENT: "View Page: Payment Options"
};
var PRESCRIPTION_FLOW_REGEX = [
    {
        regex: /^\/c\/.*\/payment.*$/,
        tracking: PAGE_VIEW_TRACKINGS.PAYMENT
    },
    {
        regex: /^\/c\/.*\/delivery.*$/,
        tracking: PAGE_VIEW_TRACKINGS.DELIVERY
    },
    {
        regex: /^\/c\/[^/]+\/price.*variant=frequency$/,
        tracking: PAGE_VIEW_TRACKINGS.SELECT_FREQUENCY
    },
    {
        regex: /^\/c\/[^/]+\/price.*variant=dosage$/,
        tracking: PAGE_VIEW_TRACKINGS.SELECT_DOSAGE
    },
    {
        regex: /^\/c\/.+\/price.+$/,
        tracking: PAGE_VIEW_TRACKINGS.TREATMENT_SUMMARY
    },
    {
        regex: /^\/c\/.+$/,
        tracking: PAGE_VIEW_TRACKINGS.MEDS_SELECTION
    }
];
var getViewPageEventName = function(pageName) {
    if (pageName) {
        switch(pageName){
            case "login":
                return "View Page: Login";
            case "register":
                return "View Page: Create an Account";
            case "forgot_password":
                return "View Page: Reset Password";
            default:
                return "View Page: ".concat(pageName);
        }
    }
    var path = getPath();
    if (path.startsWith(_constants_url_constants__WEBPACK_IMPORTED_MODULE_2__/* .URL_ORDER_BY_CONDITION */ .zg)) {
        return orderByConditionCase();
    }
    if (path.startsWith("".concat(_constants_url_constants__WEBPACK_IMPORTED_MODULE_2__/* .URL_PRESCRIPTION_FLOW */ .zI, "/"))) {
        var pathAndQueryParams = path + window.location.search;
        var result = PRESCRIPTION_FLOW_REGEX.find(function(param) {
            var regex = param.regex;
            return regex.test(pathAndQueryParams);
        });
        return (result === null || result === void 0 ? void 0 : result.tracking) || "View Page";
    }
    switch(path){
        case _constants_url_constants__WEBPACK_IMPORTED_MODULE_2__/* .URL_CHECKOUT */ .pH:
            return PAGE_VIEW_TRACKINGS.CONFIRM_ORDER;
        case _constants_url_constants__WEBPACK_IMPORTED_MODULE_2__/* .URL_CHECKOUT_PAYMENT */ .Yr:
            return PAGE_VIEW_TRACKINGS.PAYMENT;
        case _constants_url_constants__WEBPACK_IMPORTED_MODULE_2__/* .URL_CHECKOUT_DELIVERY */ .w0:
            return PAGE_VIEW_TRACKINGS.DELIVERY;
        default:
            return "View Page";
    }
};
var orderByConditionCase = function() {
    var section = (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_1__/* .getTrackingFromQueryString */ .Vv)("section");
    switch(section){
        case src_types__WEBPACK_IMPORTED_MODULE_0__/* .SectionType.medsSelection */ .b.medsSelection:
            return PAGE_VIEW_TRACKINGS.MEDS_SELECTION;
        case src_types__WEBPACK_IMPORTED_MODULE_0__/* .SectionType.productSelection */ .b.productSelection:
            return PAGE_VIEW_TRACKINGS.VIEW_MEDS;
        case src_types__WEBPACK_IMPORTED_MODULE_0__/* .SectionType.treatmentSummary */ .b.treatmentSummary:
            return PAGE_VIEW_TRACKINGS.TREATMENT_SUMMARY;
        case src_types__WEBPACK_IMPORTED_MODULE_0__/* .SectionType.freqSelection */ .b.freqSelection:
            return PAGE_VIEW_TRACKINGS.SELECT_FREQUENCY;
        case src_types__WEBPACK_IMPORTED_MODULE_0__/* .SectionType.dosageSelection */ .b.dosageSelection:
            return PAGE_VIEW_TRACKINGS.SELECT_DOSAGE;
        default:
            return "View Page: ".concat(section);
    }
};
var getPath = function() {
    var path = window.location.pathname;
    var prefixList = [
        "/en/",
        "/zh/",
        "/ja/",
        "/hi/"
    ];
    prefixList.forEach(function(prefix) {
        if (path.startsWith(prefix)) {
            path = path.slice(prefix.length - 1);
        }
    });
    return path;
};


/***/ }),

/***/ 43988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ track; },
/* harmony export */   "k": function() { return /* binding */ trackSegment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12705);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86704);
/* harmony import */ var _utils_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86229);







// @deprecated
var track = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(metric, metadata, patient) {
        var tracking, session, url;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return");
                case 5:
                    url = "".concat(src_config__WEBPACK_IMPORTED_MODULE_3__/* .config.API_URI */ .vc.API_URI, "/tracking");
                    _ctx.next = 8;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                        store: "sg",
                        platform: (patient === null || patient === void 0 ? void 0 : patient.fromPlatformEnv) || graphql_generated__WEBPACK_IMPORTED_MODULE_2__.PlatformType.Noah,
                        source: "frontend",
                        metric: metric,
                        email: session,
                        metadata: metadata,
                        utm: (0,_utils_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getUtm */ .PB)(),
                        tracking: tracking
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function track(metric, metadata, patient) {
        return _ref.apply(this, arguments);
    };
}();
var trackSegment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var url;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "".concat(src_config__WEBPACK_IMPORTED_MODULE_3__/* .config.API_URI */ .vc.API_URI, "/tracking/segment");
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data));
                case 4:
                    _ctx.next = 8;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return function trackSegment(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 99324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ track$; }
/* harmony export */ });
/* unused harmony export identify$ */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants_Countries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73252);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43988);






var identify$ = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,___WEBPACK_IMPORTED_MODULE_2__/* .trackSegment */ .k)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, param), {
                        segmentType: "identify"
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function identify$(param) {
        return _ref.apply(this, arguments);
    };
}();
var track$ = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    param.properties = param.properties || {};
                    param.properties.region = src_constants_Countries__WEBPACK_IMPORTED_MODULE_1__/* .CURRENT_COUNTRY */ .Ho;
                    _ctx.next = 4;
                    return (0,___WEBPACK_IMPORTED_MODULE_2__/* .trackSegment */ .k)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, param), {
                        segmentType: "track"
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function track$(param) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 18467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aC": function() { return /* reexport */ useAuth/* useAuth */.a; },
  "de": function() { return /* reexport */ useCheckPatientLogIn; },
  "ZR": function() { return /* reexport */ useConfig; },
  "If": function() { return /* reexport */ useContinueEDTrial; },
  "gc": function() { return /* reexport */ useCustomToast; },
  "Ls": function() { return /* reexport */ useDrBio; },
  "e8": function() { return /* reexport */ useFormatDate; },
  "BP": function() { return /* reexport */ useGetEvaluationDataFromLocalStorageQuery; },
  "Yz": function() { return /* reexport */ useInterval; },
  "eg": function() { return /* reexport */ useOrderByCondition/* useOrderByCondition */.e; },
  "Am": function() { return /* reexport */ useOrderInfo/* useOrderInfo */.A; },
  "a_": function() { return /* reexport */ useSubscribeOrder; },
  "Xq": function() { return /* reexport */ useYup/* useYupValidationResolver */.X; }
});

// UNUSED EXPORTS: IMPERSONATE_DOCTOR_ERROR, getOrderDetailQuery, useEvaluationNav, useFilterFCoachProducts, useGetProductFromConfig, useVideoConsultTimeOut

// EXTERNAL MODULE: ./src/hooks/useYup.ts
var useYup = __webpack_require__(47358);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./graphql/react-query/index.ts
var react_query = __webpack_require__(41562);
// EXTERNAL MODULE: ./src/states/index.ts + 11 modules
var states = __webpack_require__(64443);
;// CONCATENATED MODULE: ./src/hooks/useEvaluationNav.tsx
/* eslint-disable */ 









var useEvaluationNav = function() {
    var router = useRouter();
    var patient = useRecoilValue(patientState);
    var evalId = useRecoilValue(currentEvaluationIdState);
    var back = useRecoilCallback(function(param) {
        var snapshot = param.snapshot;
        return _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var step;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return snapshot.getPromise(evaluationStepperState);
                    case 2:
                        step = _ctx.sent;
                        if (!(step === "intro")) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return router.push("/");
                    case 6:
                        if (!(step === "evaluation")) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 9;
                        return backFromEvaluation();
                    case 9:
                        if (!(step === "goals")) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 12;
                        return backFromGoal();
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    });
    var backFromGoal = useRecoilCallback(function(param) {
        var set = param.set;
        return function() {
            set(evaluationStepperState, "intro");
        };
    });
    var backFromEvaluation = useRecoilCallback(function(param) {
        var set = param.set, snapshot = param.snapshot;
        return _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var sectionIndex, visits, arr, previousIndex;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return snapshot.getPromise(currentSectionIndexState);
                    case 2:
                        sectionIndex = _ctx.sent;
                        _ctx.next = 5;
                        return snapshot.getPromise(sectionVisitsState);
                    case 5:
                        visits = _ctx.sent;
                        if (!(sectionIndex === 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        set(evaluationStepperState, "intro");
                        return _ctx.abrupt("return");
                    case 9:
                        if (visits.length > 0) {
                            arr = _to_consumable_array(visits);
                            previousIndex = arr.pop();
                            set(sectionVisitsState, arr);
                            set(currentSectionIndexState, previousIndex);
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    });
    var next = useRecoilCallback(function(param) {
        var set = param.set, snapshot = param.snapshot;
        return function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(values) {
                var sectionIndex, nextIndex;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return snapshot.getPromise(currentSectionIndexState);
                        case 2:
                            sectionIndex = _ctx.sent;
                            _ctx.next = 5;
                            return onSectionCompleted(values);
                        case 5:
                            nextIndex = _ctx.sent;
                            set(sectionVisitsState, function(d) {
                                return _to_consumable_array(d).concat([
                                    sectionIndex
                                ]);
                            });
                            set(currentSectionIndexState, nextIndex);
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    var findSectionIndexByQuestionId = function(formSections, id) {
        var index = 0;
        for(; index < formSections.length; index++){
            var formSection = formSections[index];
            if (formSection.questions) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = formSection.questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var question = _step.value;
                        if (question.questionId === id) {
                            return index;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        return null;
    };
    var findSectionIndexbySectionId = function(formSections, id) {
        var index = 0;
        for(; index < formSections.length; index++){
            var formSection = formSections[index];
            if ((formSection === null || formSection === void 0 ? void 0 : formSection.sectionId) != null && formSection.sectionId === id) {
                return index;
            }
        }
        return null;
    };
    var findNextIndexes = function(formSections, question, values, indexes) {
        var ref;
        var nextIndexes = _to_consumable_array(indexes);
        var anw = values[question.questionId];
        if (question === null || question === void 0 ? void 0 : (ref = question.options) === null || ref === void 0 ? void 0 : ref.anwsers) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = question.options.anwsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var anwser = _step.value;
                    if (anwser.value === anw || anw.includes(anwser.value)) {
                        var sectionIndexGoTo = null;
                        if (anwser.goToQuestion) {
                            sectionIndexGoTo = findSectionIndexByQuestionId(formSections, anwser.goToQuestion);
                        } else if (anwser.goToSection) {
                            sectionIndexGoTo = findSectionIndexbySectionId(formSections, anwser.goToSection);
                        }
                        if (sectionIndexGoTo != null) {
                            if (!nextIndexes.includes(sectionIndexGoTo)) {
                                nextIndexes.push(sectionIndexGoTo);
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (question.defaultGoToQuestion && nextIndexes.length <= 0) {
            nextIndexes = [
                findSectionIndexByQuestionId(formSections, question.defaultGoToQuestion)
            ];
        }
        nextIndexes.sort(function(a, b) {
            return a - b;
        });
        return nextIndexes;
    };
    var pushingNewQandA = function(currentQA, question, values) {
        var ref;
        var clonedQA = _to_consumable_array(currentQA);
        var skipped = !values.hasOwnProperty(question.questionId);
        var QandA = {
            q: question.question,
            a: skipped ? null : values[question.questionId],
            questionId: question.questionId,
            skipped: skipped,
            runSpecialFunctionType: (question === null || question === void 0 ? void 0 : (ref = question.runSpecialFunction) === null || ref === void 0 ? void 0 : ref.type) || typeof (question === null || question === void 0 ? void 0 : question.runSpecialFunction) === "string" && (question === null || question === void 0 ? void 0 : question.runSpecialFunction) || ""
        };
        var existIndex = clonedQA.findIndex(function(item) {
            return item.questionId === question.questionId;
        });
        if (existIndex > -1) {
            clonedQA[existIndex] = QandA;
        } else {
            clonedQA.push(QandA);
        }
        return clonedQA;
    };
    var findNextIndex = function(clonedJumpToTree, nextIndexes, sectionIndex) {
        var nextIndex = null;
        if (clonedJumpToTree.length > 1) {
            var currentSectionIndex = clonedJumpToTree.indexOf(sectionIndex);
            if (currentSectionIndex > -1) {
                if (currentSectionIndex === clonedJumpToTree.length - 1) {
                    clonedJumpToTree = [];
                } else {
                    nextIndex = clonedJumpToTree[currentSectionIndex + 1];
                }
            } else {
                clonedJumpToTree = [];
            }
        }
        if (clonedJumpToTree.length <= 0) {
            if (nextIndexes.length > 1) {
                clonedJumpToTree = nextIndexes;
            }
            if (nextIndexes.length > 0) {
                nextIndex = nextIndexes[0];
            }
        }
        nextIndex = !nextIndex ? sectionIndex + 1 : nextIndex;
        return [
            nextIndex,
            clonedJumpToTree
        ];
    };
    var onSectionCompleted = useRecoilCallback(function(param) {
        var set = param.set, snapshot = param.snapshot;
        return function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(values) {
                var ref, ref1, evalData, localEval, localEvalData, formQandA, currentJumpToTree, currentSection, formSections, sectionIndex, totalSections, nextIndexes, clonedQA, clonedJumpToTree, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, question, skipped, ref2, nextIndex, newJumpToTree;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (!patient) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 4;
                            return graphQLClient.request(GetCompletedEvalByFilterDocument, {
                                input: {
                                    patientId: patient === null || patient === void 0 ? void 0 : patient.sysId,
                                    evaluationId: evalId
                                }
                            });
                        case 4:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 8;
                            break;
                        case 7:
                            _ctx.t0 = null;
                        case 8:
                            evalData = _ctx.t0;
                            localEval = localStorage.getItem(evaluationLSName(evalId));
                            localEvalData = JSON.parse(localEval || null);
                            formQandA = (evalData === null || evalData === void 0 ? void 0 : (ref = evalData.getCompletedEvalByFilter) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.formQandA) || (localEvalData === null || localEvalData === void 0 ? void 0 : localEvalData.formQandA) || [];
                            _ctx.next = 14;
                            return snapshot.getPromise(currentJumpToTreeState);
                        case 14:
                            currentJumpToTree = _ctx.sent;
                            _ctx.next = 17;
                            return snapshot.getPromise(currentSectionState);
                        case 17:
                            currentSection = _ctx.sent;
                            _ctx.next = 20;
                            return snapshot.getPromise(formSectionsState);
                        case 20:
                            formSections = _ctx.sent;
                            _ctx.next = 23;
                            return snapshot.getPromise(currentSectionIndexState);
                        case 23:
                            sectionIndex = _ctx.sent;
                            _ctx.next = 26;
                            return snapshot.getPromise(totalSectionsState);
                        case 26:
                            totalSections = _ctx.sent;
                            nextIndexes = [];
                            clonedQA = _to_consumable_array(formQandA);
                            clonedJumpToTree = _to_consumable_array(currentJumpToTree);
                            if (!values) {
                                _ctx.next = 48;
                                break;
                            }
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _ctx.prev = 32;
                            for(_iterator = currentSection.questions[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                question = _step.value;
                                skipped = !values.hasOwnProperty(question.questionId);
                                clonedQA = pushingNewQandA(clonedQA, question, values);
                                if (!skipped) nextIndexes = findNextIndexes(formSections, question, values, nextIndexes);
                            }
                            _ctx.next = 40;
                            break;
                        case 36:
                            _ctx.prev = 36;
                            _ctx.t1 = _ctx["catch"](32);
                            _didIteratorError = true;
                            _iteratorError = _ctx.t1;
                        case 40:
                            _ctx.prev = 40;
                            _ctx.prev = 41;
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        case 43:
                            _ctx.prev = 43;
                            if (!_didIteratorError) {
                                _ctx.next = 46;
                                break;
                            }
                            throw _iteratorError;
                        case 46:
                            return _ctx.finish(43);
                        case 47:
                            return _ctx.finish(40);
                        case 48:
                            ref2 = _sliced_to_array(findNextIndex(clonedJumpToTree, nextIndexes, sectionIndex), 2), nextIndex = ref2[0], newJumpToTree = ref2[1];
                            // await save(clonedQA, nextIndex + 1 > totalSections, sectionIndex, nextIndex, newJumpToTree);
                            set(currentJumpToTreeState, newJumpToTree);
                            return _ctx.abrupt("return", nextIndex);
                        case 51:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        32,
                        36,
                        40,
                        48
                    ],
                    [
                        41,
                        ,
                        43,
                        47
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }();
    });
    return {
        back: back,
        next: next
    };
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 4 modules
var index_esm = __webpack_require__(42377);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useCustomToast.ts


var useCustomToast = function() {
    var toast = (0,index_esm/* useToast */.pm)();
    var showShortToast = (0,react.useCallback)(function(title, status, duration, isClosable) {
        toast({
            title: title,
            status: status,
            duration: duration || 10000,
            isClosable: isClosable || true
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return {
        showShortToast: showShortToast
    };
};

;// CONCATENATED MODULE: ./src/hooks/useInterval.ts

function useInterval(callback, delay) {
    var savedCallback = (0,react.useRef)(callback);
    // Remember the latest callback if it changes.
    (0,react.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0,react.useEffect)(function() {
        // Don't schedule if no delay is specified.
        if (delay === null) {
            return;
        }
        var id = setInterval(function() {
            return savedCallback.current();
        }, delay);
        // eslint-disable-next-line consistent-return
        return function() {
            return clearInterval(id);
        };
    }, [
        delay
    ]);
}

/* harmony default export */ var hooks_useInterval = ((/* unused pure expression or super */ null && (useInterval)));

// EXTERNAL MODULE: ./src/hooks/useFetchActiveProducts.ts
var useFetchActiveProducts = __webpack_require__(50111);
// EXTERNAL MODULE: ./src/utils/envConfig.ts
var envConfig = __webpack_require__(83143);
;// CONCATENATED MODULE: ./src/hooks/useGetProductFromConfig.ts

var useGetProductFromConfig = function(productNameType) {
    if (!productNameType) return null;
    var stripeProduct = ENV_CONFIG === null || ENV_CONFIG === void 0 ? void 0 : ENV_CONFIG.stripeProduct;
    return stripeProduct === null || stripeProduct === void 0 ? void 0 : stripeProduct.find(function(product) {
        return product.uniqName === productNameType;
    });
};
/* harmony default export */ var hooks_useGetProductFromConfig = ((/* unused pure expression or super */ null && (useGetProductFromConfig)));

// EXTERNAL MODULE: ./src/constants/Countries.ts
var Countries = __webpack_require__(73252);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
;// CONCATENATED MODULE: ./src/hooks/useConfig.ts




var useConfig = function() {
    var locale = ((0,router.useRouter)() || {}).locale;
    return {
        country: Countries/* CURRENT_COUNTRY */.Ho,
        deliveryAmount: Countries/* CURRENT_COUNTRY */.Ho === generated.RegionType.Sg ? 5 : 30,
        addSuffixCountry: utils/* addTransSuffixCountry */.WZ,
        addSuffixJp: (0,utils/* addTransSuffixJp */.Kb)(locale)
    };
};

;// CONCATENATED MODULE: ./src/hooks/useFilterFCoachProducts.ts


var useFilterFCoachProducts = function(products, acuityAppointments) {
    var acuity = acuityAppointments === null || acuityAppointments === void 0 ? void 0 : acuityAppointments[0];
    var isFuture = getAcuityData(acuity).isFuture;
    products = acuity && isFuture ? products.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.uniqName) !== ProductNameType.FertilityCoach;
    }) : products;
    return {
        products: products
    };
};

// EXTERNAL MODULE: ./src/hooks/useOrderInfo.ts
var useOrderInfo = __webpack_require__(14832);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
;// CONCATENATED MODULE: ./src/hooks/useCheckPatientLogIn.ts




var useCheckPatientLogIn = function() {
    var ref;
    var ref1 = (0,next_auth_react.useSession)(), session = ref1.data, status = ref1.status;
    var user = session === null || session === void 0 ? void 0 : session.user;
    var isGuest = (session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.userType) !== generated.UserRole.Patient;
    var ref2 = (0,generated.useGetPatientInfoQuery)(react_query/* default */.Z, {}, {
        enabled: !(0,lodash.isNil)(user),
        refetchOnWindowFocus: false
    }), patientData = ref2.data, isLoading = ref2.isLoading;
    var isSessionLoading = status === "loading" || isLoading;
    return {
        isGuest: isGuest,
        user: user,
        patientInfo: patientData === null || patientData === void 0 ? void 0 : patientData.getPatientInfo,
        isSessionLoading: isSessionLoading
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./src/utils/tracking.ts
var tracking = __webpack_require__(86229);
;// CONCATENATED MODULE: ./src/hooks/useContinueEDTrial.ts








var useContinueEDTrial = function(order, productId) {
    var push = (0,router.useRouter)().push;
    var setCart = (0,es/* useSetRecoilState */.Zl)(states/* cartState */.dl);
    var ref = (0,generated.useChangeNewPriceOrderMutation)(react_query/* default */.Z, {}), changePrice = ref.mutateAsync;
    var ref1 = (0,generated.useUpdateOrderMutation)(react_query/* default */.Z, {}), updateOrder = ref1.mutateAsync;
    var ref2 = (0,generated.useInsertCartItemByIdMutation)(react_query/* default */.Z, {}), insertCartAsync = ref2.mutateAsync;
    var getCart = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return react_query/* default.request */.Z.request(generated.GetCartDocument, {
                            input: {
                                shouldReturnCalculation: true
                            }
                        });
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.getCart);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var insertCart = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(priceId) {
            var cart;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getCart();
                    case 2:
                        cart = _ctx.sent;
                        _ctx.next = 5;
                        return insertCartAsync({
                            input: {
                                sysId: cart.sysId,
                                productId: productId,
                                selectedPriceId: priceId,
                                shouldReturnCalculation: true,
                                oldOrder: {
                                    id: order.sysId,
                                    isCancelled: order.status === generated.OrderStatus.Cancel,
                                    subId: order.stripeSubscriptionId,
                                    status: order.status,
                                    priceId: order.orderPriceId,
                                    isSkippedEval: true
                                },
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                utm: (0,tracking/* getUtm */.PB)(),
                                tracking: (0,tracking/* getTracking */.Ac)()
                            }
                        }, {
                            onSuccess: function(data) {
                                if (data === null || data === void 0 ? void 0 : data.insertCartItemById) {
                                    setCart({
                                        cartItems: data.insertCartItemById.cartItems,
                                        isLoading: false
                                    });
                                }
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function insertCart(priceId) {
            return _ref.apply(this, arguments);
        };
    }();
    var onConfirmContinueTrial = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(priceId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return changePrice({
                            input: {
                                orderId: order.sysId,
                                newPriceId: priceId
                            }
                        });
                    case 2:
                        _ctx.next = 4;
                        return updateOrder({
                            input: {
                                sysId: order.sysId,
                                continueTrial: true
                            }
                        });
                    case 4:
                        _ctx.next = 6;
                        return insertCart(priceId);
                    case 6:
                        _ctx.next = 8;
                        return push("/checkout");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onConfirmContinueTrial(priceId) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onConfirmContinueTrial: onConfirmContinueTrial
    };
};

// EXTERNAL MODULE: ./src/hooks/useMomentLocale.ts
var useMomentLocale = __webpack_require__(6813);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./src/configs/common.ts
var common = __webpack_require__(75194);
// EXTERNAL MODULE: ./src/constants/Common.ts
var Common = __webpack_require__(40330);
;// CONCATENATED MODULE: ./src/hooks/useFormatDate.ts






var useFormatDate = function() {
    var locale = (0,router.useRouter)().locale;
    var region = (0,react.useMemo)(function() {
        return common/* LANGUAGE_TO_COUNTRY */.vI[locale] || generated.RegionType.Sg;
    }, [
        locale
    ]);
    var formatDate = (0,react.useCallback)(function(value) {
        return moment_default()(value).format(Common/* MMM_DATE_FORMAT_BY_COUNTRY_WITH_SPACE */.gc[region]);
    }, [
        region
    ]);
    var formatDateWithDay = (0,react.useCallback)(function(value) {
        return moment_default()(value).format(Common/* MMM_WEEK_DAY_FORMAT_BY_COUNTRY */.th[region]);
    }, [
        region
    ]);
    var formatTime = (0,react.useCallback)(function(value) {
        return moment_default()(value).format(Common/* TIME_BY_COUNTRY */.$x[region]);
    }, [
        region
    ]);
    var formatDateTime = (0,react.useCallback)(function(value) {
        if (!value) {
            return "";
        }
        return "".concat(moment_default()(value).format(Common/* MMM_DATE_FORMAT_BY_COUNTRY_WITH_SPACE */.gc[region]), ", ").concat(moment_default()(value).format(Common/* TIME_BY_COUNTRY */.$x[region]));
    }, [
        region
    ]);
    return {
        formatDate: formatDate,
        formatTime: formatTime,
        formatDateWithDay: formatDateWithDay,
        formatDateTime: formatDateTime
    };
};

;// CONCATENATED MODULE: ./src/hooks/useVideoConsultTimeOut.tsx


var useVideoConsultTimeOut = function() {
    var ref = useState(false), isStarted = ref[0], setIsStarted = ref[1];
    var ref1 = useState(false), isTimeOut = ref1[0], setIsTimeOut = ref1[1];
    var timerId = useRef(null);
    var clearTimer = function() {
        if (timerId.current) {
            clearInterval(timerId.current);
        }
    };
    var startCounter = function(from, seconds) {
        setIsStarted(true);
        clearTimer();
        var expectedDate = moment(from).add(seconds, "seconds");
        timerId.current = setInterval(function() {
            if (moment().isAfter(expectedDate)) {
                clearTimer();
                setIsTimeOut(true);
            }
        }, 1000);
    };
    var reset = function() {
        setIsStarted(false);
        setIsTimeOut(false);
        clearTimer();
    };
    return {
        isStarted: isStarted,
        isTimeOut: isTimeOut,
        startCounter: startCounter,
        reset: reset
    };
};

// EXTERNAL MODULE: ./src/hooks/useOrderByCondition.ts
var useOrderByCondition = __webpack_require__(39144);
;// CONCATENATED MODULE: ./src/hooks/useDrBio.ts


var useDrBio = function(userIdOrEmail) {
    var ref, ref1;
    var ref2 = (0,generated.useGetDoctorsByFilterQuery)(react_query/* default */.Z, {
        input: {
            userSysId: userIdOrEmail
        }
    }, {
        enabled: !userIdOrEmail.includes("@")
    }), drBySysIdRes = ref2.data;
    var ref3 = (0,generated.useGetDoctorsByFilterQuery)(react_query/* default */.Z, {
        input: {
            email: userIdOrEmail
        }
    }, {
        enabled: userIdOrEmail.includes("@")
    }), drByEmailRes = ref3.data;
    var drData = (drBySysIdRes === null || drBySysIdRes === void 0 ? void 0 : (ref = drBySysIdRes.getDoctorsByFilter) === null || ref === void 0 ? void 0 : ref[0]) || (drByEmailRes === null || drByEmailRes === void 0 ? void 0 : (ref1 = drByEmailRes.getDoctorsByFilter) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
    return {
        drData: drData
    };
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/utils/getEvaluationDataFromLocalStorage.ts
var getEvaluationDataFromLocalStorage = __webpack_require__(28849);
;// CONCATENATED MODULE: ./src/hooks/useGetEvaluationDataFromLocalStorageQuery.ts


var useGetEvaluationDataFromLocalStorageQuery = function(evaluationId) {
    return (0,react_query_es.useQuery)([
        "localEvalData",
        evaluationId
    ], function() {
        return (0,getEvaluationDataFromLocalStorage/* getEvaluationDataFromLocalStorage */.j)(evaluationId);
    });
};

// EXTERNAL MODULE: ./node_modules/graphql-ws/lib/client.mjs + 2 modules
var lib_client = __webpack_require__(62037);
// EXTERNAL MODULE: ./node_modules/react-query-subscription/es/use-subscription.js + 38 modules
var use_subscription = __webpack_require__(84066);
// EXTERNAL MODULE: ./node_modules/rxjs/dist/esm5/internal/Observable.js + 1 modules
var Observable = __webpack_require__(19293);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
;// CONCATENATED MODULE: ./src/hooks/useSubscribeOrder.ts








var getOrderDetailQuery = "query planDetailData($input: V2OrderFilterInput) {\n  viewer {\n    user {\n      patient {\n        orders(inputOrder: $input) {\n          sysId\n          status\n          stripeSubscriptionId\n          planStatus\n          orderPriceId\n          orderPrescriptionPriceId\n          isSubscriptionPaused\n          isEDTrial\n          delivery\n          isAutoRenewal\n          evaluationId\n          paymentIntentUrl\n          paymentProvider\n          deliveryMethod\n          pickupLocation {\n            type\n          }\n          deliveryAddress {\n            address\n          }\n          consultations {\n            sysId\n            videoChannelId\n            type\n            progressStatus\n          }\n          price {\n            id\n            type\n            metadata {\n              strength\n              frequency\n              quantity\n              dosage\n            }\n            productInfo {\n              id\n              name\n              uniqName\n              image {\n                noahVertical\n                noahWide\n                zoeyVertical\n                zoeyWide\n              }\n              texts {\n                product_name\n                strength\n              }\n              productInstructions {\n                localeKey\n                translatedText\n              }\n            }\n            texts {\n              frequency_quantity_display_patient\n              price_frequency\n              actual_price_display\n              dosage_display\n              frequency_display\n            }\n          }\n          oldPriceInfo {\n            id\n            metadata {\n              frequency\n              quantity\n              dosage\n            }\n            texts {\n              frequency_quantity_display_patient\n              price_frequency\n              actual_price_display\n            }\n          }\n          acuityAppointment {\n            sysId\n            calendar\n            datetime\n            doctor {\n              email\n              fullName\n            }\n          }\n          upcomingInvoice {\n            next_payment_attempt\n            period_end\n            amount_due\n            lines {\n              data {\n                amount\n                discount\n                plan {\n                  metadata\n                }\n              }\n            }\n          }\n          prescribedAfterTrialOrder {\n            sysId\n          }\n          continueTrial\n          evaluationId\n          subscription {\n            status\n            latestInvoice {\n              status\n              paymentStatus\n              hosted_invoice_url\n            }\n          }\n        }\n        cart {\n          sysId\n          status\n          cartItems {\n            price {\n              active\n              id\n              unit_amount_decimal\n            }\n            consultationSessionType\n            product {\n              active\n              uniqName\n              id\n              evaluationId\n              metadata\n              image {\n                noahVertical\n                noahWide\n              }\n            }\n          }\n        }\n        \n        latestPaymentMethod {\n          card {\n            brand\n            last4\n            exp_month\n            exp_year\n          }\n        }\n      }\n    }\n  }\n}\n";
var subcribeOrderQuery = "subscription sOrder($input: V2OrderFilterInput!) {\n  subscribeOrder(input: $input) {\n    sysId\n  }\n}";
/**
 * @see https://github.com/enisdenjo/graphql-ws#observable
 */ function fromWsClientSubscription(client, payload) {
    return new Observable/* Observable */.y(function(observer) {
        return client.subscribe(payload, {
            next: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, res;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                if (!((ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.subscribeOrder) === null || ref1 === void 0 ? void 0 : ref1.sysId)) {
                                    _ctx.next = 7;
                                    break;
                                }
                                ;
                                _ctx.next = 5;
                                return react_query/* default.request */.Z.request(getOrderDetailQuery, {
                                    input: {
                                        sysId: (ref2 = data.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscribeOrder) === null || ref3 === void 0 ? void 0 : ref3.sysId
                                    }
                                });
                            case 5:
                                res = _ctx.sent;
                                observer.next((res === null || res === void 0 ? void 0 : (ref4 = res.viewer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.patient) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.orders) === null || ref7 === void 0 ? void 0 : ref7[0]) || null);
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }(),
            error: function(err) {
                return observer.error(err);
            },
            complete: function() {
                return observer.complete();
            }
        });
    });
}
var useSubscribeOrder = function(orderId) {
    var client = (0,react.useMemo)(function() {
        return (0,lib_client/* createClient */.eI)({
            url: config/* config.WS_URI */.vc.WS_URI,
            retryAttempts: 8
        });
    }, []);
    var ref = (0,use_subscription/* useSubscription */.m)("order-detail-".concat(orderId), function() {
        return fromWsClientSubscription(client, {
            query: subcribeOrderQuery,
            variables: {
                input: {
                    sysId: orderId
                }
            }
        });
    }, {
    }), data = ref.data, isLoading = ref.isLoading;
    if (!isLoading) {
        return data || null;
    }
    return null;
};

;// CONCATENATED MODULE: ./src/hooks/index.ts





















/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IMPERSONATE_DOCTOR_ERROR; },
/* harmony export */   "a": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(828);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17563);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4480);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41562);
/* harmony import */ var src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(78262);
/* harmony import */ var src_dataTracking_events__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26346);
/* harmony import */ var src_dataTracking_segment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99324);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49384);
/* harmony import */ var src_utils_roles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64025);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86704);
/* harmony import */ var _constants_Countries__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73252);
/* harmony import */ var _constants_local_storage_names_constant__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90047);
/* harmony import */ var _states__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64443);
/* harmony import */ var _utils_tracking__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86229);
/* harmony import */ var _useTrackPageEvent__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15731);
/* provided dependency */ var process = __webpack_require__(34155);























var PARAM_ORDER = [
    "redirect"
];
var IMPERSONATE_DOCTOR_ERROR = "impersonate-doctor";
var sortParams = function(a, b) {
    return (PARAM_ORDER.indexOf(a) === -1 ? 1 : 0) - (PARAM_ORDER.indexOf(b) === -1 ? 1 : 0);
};
var useAuth = function() {
    var setAuth = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(_states__WEBPACK_IMPORTED_MODULE_15__/* .authState */ .fD);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(_states__WEBPACK_IMPORTED_MODULE_15__/* .patientState */ .ao), 2), patient = ref[0], setPatient = ref[1];
    var setPlatform = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(_states__WEBPACK_IMPORTED_MODULE_15__/* .platformState */ .QQ);
    var setDoctor = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(_states__WEBPACK_IMPORTED_MODULE_15__/* .doctorState */ .cR);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_7__.useRegisterPatientMutation)(graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), registerPatientMutation = ref2.mutateAsync;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var getCartItems = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.GetCartDocument, {
                            input: {}
                        });
                    case 2:
                        res = _ctx.sent;
                        if (!(res === null || res === void 0 ? void 0 : res.getCart.cartItems)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.getCart.cartItems);
                    case 5:
                        return _ctx.abrupt("return", []);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getCartItems() {
            return _ref.apply(this, arguments);
        };
    }();
    var updatePatientDOB = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dob) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.UpdatePatientInfoDocument, {
                            input: {
                                dob: new Date(dob)
                            }
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updatePatientDOB(dob) {
            return _ref.apply(this, arguments);
        };
    }();
    var getDOBFromLocalStorage = function(evalName) {
        var localEval = null;
        try {
            localEval = JSON.parse(localStorage.getItem((0,_constants_local_storage_names_constant__WEBPACK_IMPORTED_MODULE_20__/* .evaluationLSName */ .u5)(evalName)));
        } catch (e) {
            console.log("Cannot parse JSON: ", e);
            return "";
        }
        var dobQA = Object.values(localEval).filter(function(item) {
            return Array.isArray(item);
        }).flat().find(function(qa) {
            var ref, ref1;
            return (qa === null || qa === void 0 ? void 0 : (ref = qa.question) === null || ref === void 0 ? void 0 : (ref1 = ref.validation) === null || ref1 === void 0 ? void 0 : ref1.type) === "DOB";
        });
        return (dobQA === null || dobQA === void 0 ? void 0 : dobQA.value) || "";
    };
    var extractPtDetailFromLocalStorageEvalAnswers = function(evalName) {
        var patientDetail = {
            dob: null,
            height: 0,
            weight: 0,
            bloodPressure: null
        };
        var localEval = null;
        try {
            localEval = JSON.parse(localStorage.getItem((0,_constants_local_storage_names_constant__WEBPACK_IMPORTED_MODULE_20__/* .evaluationLSName */ .u5)(evalName)));
        } catch (e) {
            console.error("Cannot parse JSON: ", e);
            return null;
        }
        Object.values(localEval).filter(function(item) {
            return Array.isArray(item);
        }).flat().forEach(function(qa) {
            var ref, ref1;
            // not have type because validation is forced to be inserted in
            switch((ref = qa.question) === null || ref === void 0 ? void 0 : (ref1 = ref.validation) === null || ref1 === void 0 ? void 0 : ref1.type){
                case graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvaluationValidation.Dob:
                    patientDetail.dob = qa.value;
                    break;
                case graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvaluationValidation.Height:
                    patientDetail.height = qa.value;
                    break;
                case graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvaluationValidation.Weight:
                    patientDetail.weight = qa.value;
                    break;
                case graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvaluationValidation.BloodPressure:
                    patientDetail.bloodPressure = qa.value;
                    break;
                default:
                    break;
            }
        });
        return patientDetail;
    };
    var hasPermission = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(p) {
            var data;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        data = patient || p;
                        if (data) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 4:
                        return _ctx.abrupt("return", true);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,src_utils__WEBPACK_IMPORTED_MODULE_11__/* .showError */ .x2)(_ctx.t0.message);
                        console.error(_ctx.t0);
                        throw new Error("Can't check permission");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(p) {
            return _ref.apply(this, arguments);
        };
    }(), [
        patient
    ]);
    var getPatientByUserId = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var patientData;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.GetPatientInfoDocument, {});
                case 3:
                    patientData = _ctx.sent;
                    return _ctx.abrupt("return", patientData === null || patientData === void 0 ? void 0 : patientData.getPatientInfo);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), []);
    var getDoctorInfo = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var doctorRes;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.GetDoctorInAuthDocument, {});
                case 3:
                    doctorRes = _ctx.sent;
                    return _ctx.abrupt("return", doctorRes.getDoctorInAuth);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), []);
    var cartItemsIncludeCheckingEvalId = function(platform, cartItems, evalId) {
        if (!(evalId === null || evalId === void 0 ? void 0 : evalId.trim())) {
            return false;
        }
        return cartItems.some(function(item) {
            return [
                item.product.evaluationId[platform],
                item.teleConsultForSkipEval
            ].includes(evalId);
        });
    };
    var userWithFFlip = function(userData, patientData) {
        var user = {
            key: userData.sysId,
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            userType: userData.userType,
            fromPlatform: patientData.fromPlatformEnv,
            country: patientData.country
        };
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.IDENTIFY_USER */ .vc.COOKIES.IDENTIFY_USER, JSON.stringify(user));
    };
    var checkSameTreatmentInCart = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(platform, evalId, cartItems) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!cartItemsIncludeCheckingEvalId(platform, cartItems, evalId)) {
                            _ctx.next = 5;
                            break;
                        }
                        localStorage.setItem(_constants_local_storage_names_constant__WEBPACK_IMPORTED_MODULE_20__/* .CHECKOUT_ERROR */ .Bz, "1");
                        _ctx.next = 4;
                        return router.push("/checkout");
                    case 4:
                        return _ctx.abrupt("return", true);
                    case 5:
                        return _ctx.abrupt("return", false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkSameTreatmentInCart(platform, evalId, cartItems) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Get redirect url after login
   * @returns redirect url string
   */ var getRedirectUrl = function() {
        var queryParamsValue = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, router.query);
        var redirectPath = queryParamsValue.redirect || "/";
        delete queryParamsValue.type;
        delete queryParamsValue.redirect;
        var queryParamsStr = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify(queryParamsValue, {
            skipNull: true,
            sort: sortParams,
            encode: false
        });
        if (queryParamsStr === "returnUrl=/" && redirectPath.startsWith("/booking?orderId=")) {
            // this handle specific case for review consult email from the cronjob handleCronSubRenewalEmailReminder in BE
            var redirectUrl = "".concat(redirectPath, "&").concat(queryParamsStr);
            return redirectUrl;
        }
        if (queryParamsStr) {
            var redirectUrl1 = "".concat(redirectPath, "?").concat(queryParamsStr);
            return redirectUrl1;
        }
        return redirectPath;
    };
    /**
   *
   * @param {AuthState} user auth state after checking authentication
   * @param {string} email patient email
   * @param {boolean} unredirect prevent redirect after logging in
   * @returns {string} patient id
   */ var handlePatientStuffAfterLoggingIn = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user, currentPatient, email, unredirect) {
            var hasPer, queryParamsValue, redirectPath, cartItems, evalIdFromUrl, res, evalName, dob, res1, queryParamsStr, redirectUrl, redirectUrl1;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return hasPermission(currentPatient);
                    case 2:
                        hasPer = _ctx.sent;
                        if (hasPer) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 6;
                        return onLogout(false);
                    case 6:
                        throw new Error("User doesn't have permission");
                    case 7:
                        setPatient(currentPatient);
                        setAuth(user);
                        userWithFFlip(user, currentPatient);
                        setPlatform(currentPatient.fromPlatformEnv);
                        if (unredirect) {
                            _ctx.next = 41;
                            break;
                        }
                        queryParamsValue = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, router.query);
                        redirectPath = queryParamsValue.redirect || "/";
                        delete queryParamsValue.type;
                        delete queryParamsValue.redirect;
                        _ctx.next = 18;
                        return getCartItems();
                    case 18:
                        cartItems = _ctx.sent;
                        if (!(redirectPath.startsWith("/orderByCondition") && cartItems.length !== 0)) {
                            _ctx.next = 28;
                            break;
                        }
                        evalIdFromUrl = redirectPath.slice(1).split("?")[0].split("/")[1];
                        _ctx.next = 23;
                        return checkSameTreatmentInCart(currentPatient.fromPlatformEnv, evalIdFromUrl, cartItems);
                    case 23:
                        res = _ctx.sent;
                        if (!res) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 26:
                        _ctx.next = 39;
                        break;
                    case 28:
                        if (!redirectPath.startsWith("/evaluation/completion")) {
                            _ctx.next = 39;
                            break;
                        }
                        evalName = redirectPath.split("?")[0].split("/").pop();
                        dob = getDOBFromLocalStorage(evalName);
                        if (!dob) {
                            _ctx.next = 34;
                            break;
                        }
                        _ctx.next = 34;
                        return updatePatientDOB(dob);
                    case 34:
                        _ctx.next = 36;
                        return checkSameTreatmentInCart(currentPatient.fromPlatformEnv, evalName, cartItems);
                    case 36:
                        res1 = _ctx.sent;
                        if (!res1) {
                            _ctx.next = 39;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 39:
                        queryParamsStr = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify(queryParamsValue, {
                            skipNull: true,
                            sort: sortParams,
                            encode: false
                        });
                        if (queryParamsStr === "returnUrl=/" && redirectPath.startsWith("/booking?orderId=")) {
                            redirectUrl = "".concat(redirectPath, "&").concat(queryParamsStr);
                            router.replace(redirectUrl);
                        } else if (queryParamsStr) {
                            redirectUrl1 = "".concat(redirectPath, "?").concat(queryParamsStr);
                            router.replace(redirectUrl1);
                        } else {
                            router.replace(redirectPath);
                        }
                    case 41:
                        return _ctx.abrupt("return", currentPatient.sysId);
                    case 42:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePatientStuffAfterLoggingIn(user, currentPatient, email, unredirect) {
            return _ref.apply(this, arguments);
        };
    }();
    var isValidDoctorPath = function(redirectPath) {
        return redirectPath.startsWith("/doctor");
    };
    var handleDoctorStuffAfterLoggingIn = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user) {
            var queryParamsValue, redirectPath, d;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setAuth(user);
                        queryParamsValue = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, router.query);
                        redirectPath = queryParamsValue.redirect || "/";
                        _ctx.next = 5;
                        return getDoctorInfo();
                    case 5:
                        d = _ctx.sent;
                        setDoctor(d);
                        if (!isValidDoctorPath(redirectPath)) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 10;
                        return router.push(redirectPath);
                    case 10:
                        return _ctx.abrupt("return");
                    case 11:
                        _ctx.next = 13;
                        return router.push("/doctor");
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDoctorStuffAfterLoggingIn(user) {
            return _ref.apply(this, arguments);
        };
    }();
    var isValidOpsPath = function(redirectPath) {
        return redirectPath.startsWith("/ops");
    };
    var handleOpsStuffAfterLoggingIn = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user) {
            var queryParamsValue, redirectPath;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setAuth(user);
                        queryParamsValue = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, router.query);
                        redirectPath = queryParamsValue.redirect || "/";
                        if (!isValidOpsPath(redirectPath)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return router.push(redirectPath);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOpsStuffAfterLoggingIn(user) {
            return _ref.apply(this, arguments);
        };
    }();
    // return: patient id
    var onLogin = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var email, password, _unredirect, unredirect, _impersonate, impersonate, cb, lowerCaseEmail, ref, res, session, user, currentPatient;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email, password = param.password, _unredirect = param.unredirect, unredirect = _unredirect === void 0 ? false : _unredirect, _impersonate = param.impersonate, impersonate = _impersonate === void 0 ? false : _impersonate, cb = param.cb;
                        _ctx.prev = 1;
                        lowerCaseEmail = email.toLowerCase();
                        if (!impersonate) {
                            _ctx.next = 16;
                            break;
                        }
                        ;
                        _ctx.next = 7;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ImpersonateDocument, {
                            input: {
                                email: lowerCaseEmail
                            }
                        });
                    case 7:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.impersonate) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Impersonation failed");
                    case 10:
                        if (!(0,src_utils_roles__WEBPACK_IMPORTED_MODULE_12__/* .isDoctorRole */ .xY)((ref = res.impersonate.user) === null || ref === void 0 ? void 0 : ref.userType)) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(IMPERSONATE_DOCTOR_ERROR);
                    case 12:
                        _ctx.next = 14;
                        return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("credentials", {
                            isImpersonate: true,
                            impersonationData: JSON.stringify(res.impersonate),
                            redirect: false
                        });
                    case 14:
                        _ctx.next = 18;
                        break;
                    case 16:
                        _ctx.next = 18;
                        return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("credentials", {
                            email: lowerCaseEmail,
                            password: password,
                            isImpersonate: false,
                            redirect: false
                        });
                    case 18:
                        _ctx.next = 20;
                        return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.getSession)();
                    case 20:
                        session = _ctx.sent;
                        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.ACCESS_TOKEN */ .vc.COOKIES.ACCESS_TOKEN, session === null || session === void 0 ? void 0 : session.accessToken);
                        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.REFRESH_TOKEN */ .vc.COOKIES.REFRESH_TOKEN, session === null || session === void 0 ? void 0 : session.refreshToken);
                        graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].setHeader */ .Z.setHeader("Authorization", "Bearer ".concat(session === null || session === void 0 ? void 0 : session.accessToken));
                        user = (session || {}).user;
                        if (user === null || user === void 0 ? void 0 : user.id) {
                            js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_22__/* .trackingUserId */ .yC, user === null || user === void 0 ? void 0 : user.id, {
                                expires: 365
                            });
                        }
                        // in case impersonate false:
                        if (impersonate && (user === null || user === void 0 ? void 0 : user.userType) !== graphql_generated__WEBPACK_IMPORTED_MODULE_7__.UserRole.Patient) {
                            cb();
                        }
                        ;
                        if (!(0,src_utils_roles__WEBPACK_IMPORTED_MODULE_12__/* .isPatientRole */ .$2)(user === null || user === void 0 ? void 0 : user.userType)) {
                            _ctx.next = 32;
                            break;
                        }
                        _ctx.next = 31;
                        return getPatientByUserId();
                    case 31:
                        currentPatient = _ctx.sent;
                    case 32:
                        if (!(0,src_utils_roles__WEBPACK_IMPORTED_MODULE_12__/* .isDoctorRole */ .xY)(user === null || user === void 0 ? void 0 : user.userType)) {
                            _ctx.next = 36;
                            break;
                        }
                        _ctx.next = 35;
                        return handleDoctorStuffAfterLoggingIn(user);
                    case 35:
                        return _ctx.abrupt("return", "");
                    case 36:
                        if (!(0,src_utils_roles__WEBPACK_IMPORTED_MODULE_12__/* .isPatientRole */ .$2)(user === null || user === void 0 ? void 0 : user.userType)) {
                            _ctx.next = 40;
                            break;
                        }
                        _ctx.next = 39;
                        return handlePatientStuffAfterLoggingIn(user, currentPatient, lowerCaseEmail, unredirect);
                    case 39:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 40:
                        _ctx.t0 = user === null || user === void 0 ? void 0 : user.userType;
                        _ctx.next = _ctx.t0 === graphql_generated__WEBPACK_IMPORTED_MODULE_7__.UserRole.Admin ? 43 : 46;
                        break;
                    case 43:
                        _ctx.next = 45;
                        return handleOpsStuffAfterLoggingIn(user);
                    case 45:
                        return _ctx.abrupt("return", "");
                    case 46:
                        throw new Error('Invalid user type: "'.concat(user === null || user === void 0 ? void 0 : user.userType, '"'));
                    case 47:
                        _ctx.next = 53;
                        break;
                    case 49:
                        _ctx.prev = 49;
                        _ctx.t1 = _ctx["catch"](1);
                        console.error(_ctx.t1);
                        throw _ctx.t1;
                    case 53:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    49
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var onRegister = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var email, password, locale, country, anonymousPatientId, _fromPlatform, fromPlatform, lowerCaseEmail, patientDetail, queryParamsValue, redirectPath, evalName, payload, ref, ref1, ref2;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email, password = param.password, locale = param.locale, country = param.country, anonymousPatientId = param.anonymousPatientId, _fromPlatform = param.fromPlatform, fromPlatform = _fromPlatform === void 0 ? graphql_generated__WEBPACK_IMPORTED_MODULE_7__.PlatformType.Noah : _fromPlatform;
                        lowerCaseEmail = email.toLowerCase();
                        patientDetail = {
                            dob: null,
                            height: 0,
                            weight: 0,
                            bloodPressure: null
                        };
                        queryParamsValue = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, router.query);
                        redirectPath = queryParamsValue.redirect || "/";
                        // guest flow
                        if (redirectPath.startsWith("/evaluation/completion")) {
                            evalName = redirectPath.split("?")[0].split("/").pop();
                            patientDetail = extractPtDetailFromLocalStorageEvalAnswers(evalName);
                        }
                        payload = {
                            input: {
                                email: lowerCaseEmail,
                                password: password,
                                fromPlatformEnv: fromPlatform,
                                dob: patientDetail.dob ? new Date(patientDetail.dob).toISOString() : null,
                                height: patientDetail.height,
                                weight: patientDetail.weight,
                                bloodPressure: patientDetail.bloodPressure,
                                country: country,
                                locale: locale || _constants_Countries__WEBPACK_IMPORTED_MODULE_14__/* .CURRENT_DEFAULT_LANG */ .S9[_constants_Countries__WEBPACK_IMPORTED_MODULE_14__/* .CURRENT_COUNTRY */ .Ho],
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                utm: (0,_utils_tracking__WEBPACK_IMPORTED_MODULE_16__/* .getUtm */ .PB)(),
                                anonymousId: (0,_useTrackPageEvent__WEBPACK_IMPORTED_MODULE_17__/* .getAnonymousId */ .yQ)(),
                                tracking: (0,_utils_tracking__WEBPACK_IMPORTED_MODULE_16__/* .getTracking */ .Ac)(),
                                anonymousPatientId: anonymousPatientId
                            }
                        };
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return registerPatientMutation(payload);
                    case 10:
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](7);
                        ;
                        console.error(_ctx.t0);
                        throw new Error(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.message);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var cleanupCookies = function() {
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.NEXT_AUTH_SESSION_TOKEN */ .vc.COOKIES.NEXT_AUTH_SESSION_TOKEN, {
            path: "",
            domain: process.env.NEXT_PUBLIC_DOMAIN
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.NEXT_AUTH_SESSION_TOKEN */ .vc.COOKIES.NEXT_AUTH_SESSION_TOKEN, {
            path: "",
            domain: ".".concat(process.env.NEXT_PUBLIC_DOMAIN)
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.NEXT_AUTH_CALLBACK_URL */ .vc.COOKIES.NEXT_AUTH_CALLBACK_URL);
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.ACCESS_TOKEN */ .vc.COOKIES.ACCESS_TOKEN);
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.REFRESH_TOKEN */ .vc.COOKIES.REFRESH_TOKEN);
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.NEXT_LOCALE */ .vc.COOKIES.NEXT_LOCALE);
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove(src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_22__/* .trackingUserId */ .yC);
    };
    var onLogout = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var redirect, ref, platform, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    redirect = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                    _ctx.prev = 1;
                    ;
                    platform = patient === null || patient === void 0 ? void 0 : patient.fromPlatformEnv;
                    _ctx.next = 6;
                    return (0,src_dataTracking_segment__WEBPACK_IMPORTED_MODULE_10__/* .track$ */ .s)({
                        event: src_dataTracking_events__WEBPACK_IMPORTED_MODULE_9__/* .TRACKING_EVENTS_2.signedOut */ .er.signedOut,
                        anonymousId: (0,_useTrackPageEvent__WEBPACK_IMPORTED_MODULE_17__/* .getAnonymousId */ .yQ)(),
                        userId: patient === null || patient === void 0 ? void 0 : (ref = patient.user) === null || ref === void 0 ? void 0 : ref.id,
                        properties: {
                            platform: platform
                        }
                    });
                case 6:
                    _ctx.next = 8;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signOut)();
                case 8:
                    _ctx.next = 13;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("Failed to signout");
                case 13:
                    graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].setHeader */ .Z.setHeader(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.ACCESS_TOKEN */ .vc.COOKIES.ACCESS_TOKEN, "");
                    localStorage.clear();
                    cleanupCookies();
                    if (redirect) {
                        window.location.href = "/auth";
                    }
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    })), [
        patient
    ]);
    var onSendResetPasswordEmail = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.SendResetPasswordEmailDocument, {
                            input: {
                                email: values.email.toLowerCase(),
                                url: window.location.origin,
                                locale: values.locale
                            }
                        });
                    case 3:
                        _ctx.next = 9;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        throw new Error(_ctx.t0.message);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function onSendResetPasswordEmail(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkTokenInfo = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var session, ref, user, accessToken, refreshToken, d, patientData, hasPer;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.getSession)();
                case 2:
                    session = _ctx.sent;
                    ref = session || {}, user = ref.user, accessToken = ref.accessToken, refreshToken = ref.refreshToken;
                    if (!(!(user === null || user === void 0 ? void 0 : user.userType) || !accessToken)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 6:
                    js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.ACCESS_TOKEN */ .vc.COOKIES.ACCESS_TOKEN, accessToken);
                    js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(_config__WEBPACK_IMPORTED_MODULE_13__/* .config.COOKIES.REFRESH_TOKEN */ .vc.COOKIES.REFRESH_TOKEN, refreshToken);
                    graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"].setHeader */ .Z.setHeader("Authorization", "Bearer ".concat(accessToken));
                    if (!(0,src_utils_roles__WEBPACK_IMPORTED_MODULE_12__/* .isDoctorRole */ .xY)(user.userType)) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.next = 12;
                    return getDoctorInfo();
                case 12:
                    d = _ctx.sent;
                    if (d) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 15:
                    setAuth(user);
                    setDoctor(d);
                    return _ctx.abrupt("return");
                case 18:
                    if (!(0,src_utils_roles__WEBPACK_IMPORTED_MODULE_12__/* .isPatientRole */ .$2)(user.userType)) {
                        _ctx.next = 36;
                        break;
                    }
                    _ctx.next = 21;
                    return getPatientByUserId();
                case 21:
                    patientData = _ctx.sent;
                    if (patientData) {
                        _ctx.next = 24;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 24:
                    setAuth(user);
                    setPatient(patientData);
                    setPlatform(patientData.fromPlatformEnv);
                    _ctx.next = 29;
                    return hasPermission(patientData);
                case 29:
                    hasPer = _ctx.sent;
                    if (hasPer) {
                        _ctx.next = 35;
                        break;
                    }
                    console.log("checkTokenInfo");
                    _ctx.next = 34;
                    return onLogout(false);
                case 34:
                    throw new Error("User doesn't have permission");
                case 35:
                    return _ctx.abrupt("return");
                case 36:
                    _ctx.t0 = user.userType;
                    _ctx.next = _ctx.t0 === graphql_generated__WEBPACK_IMPORTED_MODULE_7__.UserRole.Admin ? 39 : 41;
                    break;
                case 39:
                    setAuth(user);
                    return _ctx.abrupt("break", 42);
                case 41:
                    return _ctx.abrupt("break", 42);
                case 42:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    })), [
        setAuth,
        setPatient,
        setPlatform
    ]);
    // return: patient id
    var onGoogleSSOLogin = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var redirectUrl;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    redirectUrl = getRedirectUrl();
                    _ctx.next = 4;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("google", {
                        redirect: true,
                        callbackUrl: redirectUrl
                    });
                case 4:
                    return _ctx.abrupt("return", "");
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    throw _ctx.t0;
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // return: patient id
    var onFacebookSSOLogin = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var redirectUrl;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    redirectUrl = getRedirectUrl();
                    _ctx.next = 4;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("facebook", {
                        redirect: true,
                        callbackUrl: redirectUrl
                    });
                case 4:
                    return _ctx.abrupt("return", "");
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    throw _ctx.t0;
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var onYahooSSOLogin = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var redirectUrl;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    redirectUrl = getRedirectUrl();
                    _ctx.next = 4;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("yahoo", {
                        redirect: true,
                        callbackUrl: redirectUrl
                    });
                case 4:
                    return _ctx.abrupt("return", "");
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    throw _ctx.t0;
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var onLineSSOLogin = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var redirectUrl;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    redirectUrl = getRedirectUrl();
                    _ctx.next = 4;
                    return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("line", {
                        redirect: true,
                        callbackUrl: redirectUrl
                    });
                case 4:
                    return _ctx.abrupt("return", "");
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    throw _ctx.t0;
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var createPatientForLoginUser = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(platform, provider) {
            var session, user, ref, lowerCaseEmail, patientDetail, redirectPath, evalName, password, payload, ref1, ref2, ref3, ref4, ref5, ref6;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsLoading(true);
                        _ctx.next = 4;
                        return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.getSession)();
                    case 4:
                        session = _ctx.sent;
                        user = (session || {}).user;
                        if (user === null || user === void 0 ? void 0 : user.patient) {
                            _ctx.next = 26;
                            break;
                        }
                        ;
                        lowerCaseEmail = user === null || user === void 0 ? void 0 : (ref = user.email) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                        patientDetail = {
                            dob: null,
                            height: 0,
                            weight: 0,
                            bloodPressure: null
                        };
                        redirectPath = router.asPath || "/";
                        // guest flow
                        if (redirectPath.startsWith("/evaluation/completion")) {
                            evalName = redirectPath.split("?")[0].split("/").pop();
                            patientDetail = extractPtDetailFromLocalStorageEvalAnswers(evalName);
                        }
                        password = (0,src_utils__WEBPACK_IMPORTED_MODULE_11__/* .uuidGen */ .Ih)();
                        payload = {
                            input: {
                                email: lowerCaseEmail,
                                firstName: user === null || user === void 0 ? void 0 : user.firstName,
                                lastName: user === null || user === void 0 ? void 0 : user.lastName,
                                password: password,
                                fromPlatformEnv: platform,
                                height: patientDetail.height,
                                weight: patientDetail.weight,
                                country: _constants_Countries__WEBPACK_IMPORTED_MODULE_14__/* .CURRENT_COUNTRY */ .Ho,
                                locale: _constants_Countries__WEBPACK_IMPORTED_MODULE_14__/* .CURRENT_DEFAULT_LANG */ .S9[_constants_Countries__WEBPACK_IMPORTED_MODULE_14__/* .CURRENT_COUNTRY */ .Ho],
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                utm: (0,_utils_tracking__WEBPACK_IMPORTED_MODULE_16__/* .getUtm */ .PB)(),
                                tracking: (0,_utils_tracking__WEBPACK_IMPORTED_MODULE_16__/* .getTracking */ .Ac)(),
                                user: user,
                                provider: provider || "email",
                                dob: patientDetail.dob ? new Date(patientDetail.dob).toISOString() : null,
                                bloodPressure: patientDetail.bloodPressure
                            }
                        };
                        _ctx.prev = 14;
                        _ctx.next = 17;
                        return registerPatientMutation(payload);
                    case 17:
                        _ctx.next = 19;
                        return onLogin({
                            email: lowerCaseEmail,
                            password: password,
                            unredirect: true
                        });
                    case 19:
                        _ctx.next = 26;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](14);
                        ;
                        console.error(_ctx.t0);
                        throw new Error(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.errors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.message);
                    case 26:
                        _ctx.next = 33;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t1 = _ctx["catch"](0);
                        ;
                        console.error(_ctx.t1);
                        throw new Error(_ctx.t1 === null || _ctx.t1 === void 0 ? void 0 : (ref4 = _ctx.t1.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.errors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.message);
                    case 33:
                        _ctx.prev = 33;
                        setIsLoading(false);
                        return _ctx.finish(33);
                    case 36:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    28,
                    33,
                    36
                ],
                [
                    14,
                    21
                ]
            ]);
        }));
        return function(platform, provider) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onLogin,
        registerPatientMutation,
        router.asPath
    ]);
    return {
        onLogin: onLogin,
        onLogout: onLogout,
        onRegister: onRegister,
        hasPermission: hasPermission,
        getPatient: getPatientByUserId,
        checkTokenInfo: checkTokenInfo,
        onSendResetPasswordEmail: onSendResetPasswordEmail,
        onGoogleSSOLogin: onGoogleSSOLogin,
        onFacebookSSOLogin: onFacebookSSOLogin,
        onYahooSSOLogin: onYahooSSOLogin,
        onLineSSOLogin: onLineSSOLogin,
        createPatientForLoginUser: createPatientForLoginUser,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 50111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41562);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64443);








var useFetchActiveProducts = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .activeProductsState */ .JN), 2), activeProducts = ref[0], setActiveProducts = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .isFetchingActiveProductsState */ .aA), 2), isFetching = ref1[0], setIsFetching = ref1[1];
    var patient = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .patientState */ .ao);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!patient) {
            setIsFetching(false);
            return;
        }
        var fetchCurrentSub = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var activeProductData;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsFetching(true);
                            _ctx.next = 4;
                            return graphql_react_query__WEBPACK_IMPORTED_MODULE_4__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_3__.GetActiveProductsDocument, {
                                input: {}
                            });
                        case 4:
                            activeProductData = _ctx.sent;
                            setActiveProducts(activeProductData.getActiveProducts);
                            setIsFetching(false);
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            throw new Error("Cannot get active products");
                        case 12:
                            _ctx.prev = 12;
                            setIsFetching(false);
                            return _ctx.finish(12);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9,
                        12,
                        15
                    ]
                ]);
            }));
            return function fetchCurrentSub() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchCurrentSub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        patient
    ]);
    return {
        activeProducts: activeProducts,
        isFetching: isFetching
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFetchActiveProducts);


/***/ }),

/***/ 6813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_configs_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75194);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var useMomentLocale = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var locale = router.locale;
    var momentLocale = (0,src_configs_common__WEBPACK_IMPORTED_MODULE_1__/* .MOMENT_LOCALE */ .S$)(locale);
    return {
        momentLocale: momentLocale
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMomentLocale);


/***/ }),

/***/ 39144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useOrderByCondition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var src_constants_url_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97479);
/* harmony import */ var src_states_orderByCondition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65439);
/* harmony import */ var src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3247);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49384);








var useOrderByCondition = function(conditionId // only need conditionId when use getFirstSectionState. Most cases is go to next section
) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilState */ .FV)(src_states_orderByCondition__WEBPACK_IMPORTED_MODULE_3__/* .sectionStateHistory */ .RD), 2), sectionHistory = ref[0], setSectionHistory = ref[1];
    /**
   * Get the very first step after complete the eval
   * @param parSkipEval flag skip eval
   * @param parSkipIntro flag skip intro
   * @returns the first state
   */ var getFirstSectionState = function(parSkipEval, parSkipIntro) {
        // set default state is medication steps
        var varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.medsSelection */ .b.medsSelection;
        if (parSkipEval === true) {
            varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.DOBInput */ .b.DOBInput;
        } else if (parSkipIntro === true || (0,src_utils__WEBPACK_IMPORTED_MODULE_5__/* .checkIsConsultOnly */ .Pf)(conditionId, null)) {
            varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.productSelection */ .b.productSelection;
        }
        // set first history as eval, the second is the landing state after complete the eval
        setSectionHistory([
            src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.evaluationQuestions */ .b.evaluationQuestions,
            varResult
        ]);
        return varResult;
    };
    /**
   * Get the next section state base on the current state
   * @param parCurrentState current state
   * @param parIsLastProductGroup flag if the product is the last one
   * @returns next section state
   */ var getNextSectionState = function(parCurrentState, parIsLastProductGroup) {
        var varResult = parCurrentState;
        switch(parCurrentState){
            case src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.DOBInput */ .b.DOBInput:
                if ((0,src_utils__WEBPACK_IMPORTED_MODULE_5__/* .checkIsConsultOnly */ .Pf)(conditionId, null)) {
                    varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.productSelection */ .b.productSelection;
                    break;
                }
                varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.medsSelection */ .b.medsSelection;
                break;
            case src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.medsSelection */ .b.medsSelection:
                varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.productSelection */ .b.productSelection;
                break;
            case src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.productSelection */ .b.productSelection:
                varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.treatmentSummary */ .b.treatmentSummary;
                break;
            case src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.treatmentSummary */ .b.treatmentSummary:
                if (!parIsLastProductGroup) {
                    varResult = src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_4__/* .SectionType.productSelection */ .b.productSelection;
                    break;
                }
                router.push(src_constants_url_constants__WEBPACK_IMPORTED_MODULE_2__/* .URL_CHECKOUT */ .pH);
                break;
            default:
                break;
        }
        setSectionHistory((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sectionHistory).concat([
            varResult
        ]));
        return varResult;
    };
    var getPreSectionState = function(parCurrentState) {
        var varResult = parCurrentState;
        varResult = sectionHistory[sectionHistory.length - 2];
        setSectionHistory(sectionHistory.slice(0, sectionHistory.length - 1));
        return varResult;
    };
    var goToNextSection = function(curSection) {
        var isLastProductGroup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var nextSection = getNextSectionState(curSection, isLastProductGroup);
        goToSection(nextSection);
    };
    var goToSection = function(section) {
        router.query.section = section;
        router.push(router, undefined, {
            shallow: true
        });
    };
    return {
        getFirstSectionState: getFirstSectionState,
        getNextSectionState: getNextSectionState,
        getPreSectionState: getPreSectionState,
        goToNextSection: goToNextSection,
        goToSection: goToSection
    };
};


/***/ }),

/***/ 14832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useOrderInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41562);






var useOrderInfo = function(orderId) {
    var ref, ref1, ref2;
    var ref3 = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_1__.useGetOrderDetailWithPatientQuery)(graphql_react_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        input: {
            orderId: orderId
        }
    }), res = ref3.data, isLoading = ref3.isLoading, orderRefetch = ref3.refetch;
    var ref4 = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_1__.useGetExtraInfoForEditingOrderQuery)(graphql_react_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        input: {
            orderId: orderId
        }
    }), extraInfoRes = ref4.data, extraInfoLoading = ref4.isLoading, extraRefetch = ref4.refetch;
    var refetch = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return orderRefetch();
                    case 2:
                        _ctx.next = 4;
                        return extraRefetch();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refetch() {
            return _ref.apply(this, arguments);
        };
    }();
    var refetchOrder = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return orderRefetch();
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.getOrderDetailWithPatient) === null || ref === void 0 ? void 0 : ref.order);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refetchOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        loading: isLoading || extraInfoLoading,
        data: isLoading ? null : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res === null || res === void 0 ? void 0 : (ref = res.getOrderDetailWithPatient) === null || ref === void 0 ? void 0 : ref.order), {
            // The affiliate coupon is surfaced at the TOP LEVEL of the query
            // (getOrderDetailWithPatient.affiliateCoupon), not on the nested `order`:
            // gqlg de-dupes the AffiliateCoupon type and skips re-expanding it on the
            // top-level `order` (the generated `order` type has no affiliateCoupon field
            // at all). Merge the top-level coupon onto the order object so
            // ProductSelector's affiliate-lock engages.
            affiliateCoupon: res === null || res === void 0 ? void 0 : (ref1 = res.getOrderDetailWithPatient) === null || ref1 === void 0 ? void 0 : ref1.affiliateCoupon,
            patientSnapshot: res === null || res === void 0 ? void 0 : (ref2 = res.getOrderDetailWithPatient) === null || ref2 === void 0 ? void 0 : ref2.patient,
            extraInfo: extraInfoRes === null || extraInfoRes === void 0 ? void 0 : extraInfoRes.getExtraInfoForEditingOrder
        }),
        refetch: refetch,
        refetchOrder: refetchOrder
    };
};


/***/ }),

/***/ 15731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_b": function() { return /* binding */ trackPageEvent; },
/* harmony export */   "sX": function() { return /* binding */ useTrackPageEvent; },
/* harmony export */   "yQ": function() { return /* binding */ getAnonymousId; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
/* harmony import */ var src_constants_Countries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73252);
/* harmony import */ var src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78262);
/* harmony import */ var src_dataTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43988);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64443);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49384);








var getAnonymousId = function() {
    var anonymousId = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_7__/* .trackingAnonymousId */ .bc);
    if (!anonymousId) {
        anonymousId = (0,src_utils__WEBPACK_IMPORTED_MODULE_6__/* .uuidGen */ .Ih)();
    }
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_7__/* .trackingAnonymousId */ .bc, anonymousId, {
        expires: 365
    });
    return anonymousId;
};
var trackPageEvent = function(name, category) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if ( false || options.enabled === false) {
        // Don't track page view on server-side
        return;
    }
    (0,src_dataTracking__WEBPACK_IMPORTED_MODULE_4__/* .trackSegment */ .k)({
        segmentType: "page",
        anonymousId: getAnonymousId(),
        name: name,
        category: category,
        userId: js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(src_constants_cookie_names_constant__WEBPACK_IMPORTED_MODULE_7__/* .trackingUserId */ .yC),
        properties: {
            platform: options.platform,
            region: src_constants_Countries__WEBPACK_IMPORTED_MODULE_3__/* .CURRENT_COUNTRY */ .Ho
        }
    });
};
var useTrackPageEvent = function(name, category) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var patient = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .patientState */ .ao);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        trackPageEvent(name, category, {
            enabled: options.enabled,
            platform: patient === null || patient === void 0 ? void 0 : patient.fromPlatformEnv
        });
    }, [
        name,
        category,
        options.enabled,
        patient
    ]);
};


/***/ }),

/***/ 47358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useYupValidationResolver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var useYupValidationResolver = function(validationSchema) {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var values, _type;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return validationSchema.validate(data, {
                            abortEarly: false
                        });
                    case 3:
                        values = _ctx.sent;
                        return _ctx.abrupt("return", {
                            values: values,
                            errors: {}
                        });
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        return _ctx.abrupt("return", {
                            values: {},
                            errors: _ctx.t0.inner.reduce(function(allErrors, currentError) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, allErrors), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, currentError.path, {
                                    type: (_type = currentError.type) !== null && _type !== void 0 ? _type : "validation",
                                    message: currentError.message
                                }));
                            }, {})
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        validationSchema
    ]);
};


/***/ }),

/***/ 65439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ overwriteProductIdState; },
/* harmony export */   "Bg": function() { return /* binding */ selectedProductsState; },
/* harmony export */   "Qf": function() { return /* binding */ savedDOBState; },
/* harmony export */   "RD": function() { return /* binding */ sectionStateHistory; },
/* harmony export */   "Tp": function() { return /* binding */ selectedPricesState; },
/* harmony export */   "aD": function() { return /* binding */ currentProductGroupIndexState; },
/* harmony export */   "vf": function() { return /* binding */ conditionState; }
/* harmony export */ });
/* unused harmony exports pendingPrescriptionOrdersState, pendingBookingOrdersState, sectionState, conditionSettingState, notesState, currentVariationIndexState, currentProductState, selectedVariationsState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41562);
/* harmony import */ var src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3247);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70962);
/* harmony import */ var _generalState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19449);
/* harmony import */ var _stripeState__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63224);
/* eslint-disable no-prototype-builtins */ 










var conditionState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONDITION_STATE */ .Z.CONDITION_STATE,
    default: null
});
var pendingPrescriptionOrdersState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZ)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].PENDING_PRESCRIPTION_ORDERS_STATE */ .Z.PENDING_PRESCRIPTION_ORDERS_STATE,
    get: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var get, patient, orderData, pendingPrescriptionOrders;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        get = param.get;
                        patient = get(_generalState__WEBPACK_IMPORTED_MODULE_7__/* .patientState */ .ao);
                        _ctx.next = 4;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_4__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_3__.GetOrderByFilterDocument, {
                            input: {
                                patientId: patient.sysId,
                                statuses: [
                                    graphql_generated__WEBPACK_IMPORTED_MODULE_3__.OrderStatus.PendingPrescription,
                                    graphql_generated__WEBPACK_IMPORTED_MODULE_3__.OrderStatus.PendingPrescriptionFu
                                ]
                            }
                        });
                    case 4:
                        orderData = _ctx.sent;
                        pendingPrescriptionOrders = orderData.getOrderByFilter || [];
                        return _ctx.abrupt("return", pendingPrescriptionOrders.length === 0 ? [] : pendingPrescriptionOrders.filter(function(item) {
                            return moment__WEBPACK_IMPORTED_MODULE_1___default()((item === null || item === void 0 ? void 0 : item.expiredAt) || 0).isAfter(Date.now(), "milliseconds");
                        }).map(function(item) {
                            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                sysId: item.sysId
                            }, item);
                        }));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()
});
var pendingBookingOrdersState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZ)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].PENDING_BOOKING_ORDERS_STATE */ .Z.PENDING_BOOKING_ORDERS_STATE,
    get: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var get, patient, orderData, pendingBookingOrders;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        get = param.get;
                        get(_generalState__WEBPACK_IMPORTED_MODULE_7__/* .routerChangeState */ .Ci);
                        patient = get(_generalState__WEBPACK_IMPORTED_MODULE_7__/* .patientState */ .ao);
                        _ctx.next = 5;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_4__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_3__.GetOrderByFilterDocument, {
                            input: {
                                patientId: patient === null || patient === void 0 ? void 0 : patient.sysId,
                                statuses: [
                                    graphql_generated__WEBPACK_IMPORTED_MODULE_3__.OrderStatus.PendingBooking,
                                    graphql_generated__WEBPACK_IMPORTED_MODULE_3__.OrderStatus.PendingBookingFu
                                ]
                            }
                        });
                    case 5:
                        orderData = _ctx.sent;
                        pendingBookingOrders = orderData.getOrderByFilter || [];
                        return _ctx.abrupt("return", pendingBookingOrders.length === 0 ? [] : pendingBookingOrders.map(function(item) {
                            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                sysId: item.sysId
                            }, item);
                        }));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()
});
var sectionState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].SECTION_STATE */ .Z.SECTION_STATE,
    default: src_types_orderByCondition__WEBPACK_IMPORTED_MODULE_5__/* .SectionType.medsSelection */ .b.medsSelection
});
var sectionStateHistory = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].SECTION_STATE_HISTORY */ .Z.SECTION_STATE_HISTORY,
    default: []
});
var conditionSettingState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZ)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONDITION_SETTING_STATE */ .Z.CONDITION_SETTING_STATE,
    get: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var get, condition, productData;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        get = param.get;
                        condition = get(conditionState);
                        _ctx.next = 4;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_4__/* ["default"].request */ .Z.request(graphql_generated__WEBPACK_IMPORTED_MODULE_3__.GetProductByFilterDocument, {
                            input: {
                                id: condition
                            }
                        });
                    case 4:
                        productData = _ctx.sent;
                        return _ctx.abrupt("return", condition ? productData === null || productData === void 0 ? void 0 : productData.getProductByFilter[0] : null);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()
});
var currentProductGroupIndexState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CURRENT_PRODUCT_GROUP_INDEX_STATE */ .Z.CURRENT_PRODUCT_GROUP_INDEX_STATE,
    default: 0
});
var selectedProductsState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].SELECTED_PRODUCT_STATE */ .Z.SELECTED_PRODUCT_STATE,
    default: {}
});
var selectedPricesState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].SELECTED_PRICES_STATE */ .Z.SELECTED_PRICES_STATE,
    default: {}
});
var notesState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].NOTES_STATE */ .Z.NOTES_STATE,
    default: ""
});
var currentVariationIndexState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CURRENT_VARIATION_INDEX_STATE */ .Z.CURRENT_VARIATION_INDEX_STATE,
    default: 0
});
var currentProductState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZ)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CURRENT_PRODUCT_STATE */ .Z.CURRENT_PRODUCT_STATE,
    get: function(param) {
        var get = param.get;
        var product = get(selectedProductsState)[get(currentProductGroupIndexState)];
        if (product) {
            return get((0,_stripeState__WEBPACK_IMPORTED_MODULE_8__/* .productItemState */ .D)(product));
        }
        return null;
    }
});
var selectedVariationsState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].SELECTED_VARIATIONS_STATE */ .Z.SELECTED_VARIATIONS_STATE,
    default: {}
});
var overwriteProductIdState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].OVERWRITE_PRODUCT_ID_STATE */ .Z.OVERWRITE_PRODUCT_ID_STATE,
    default: ""
});
var savedDOBState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: _constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].SAVED_DOB_STATE */ .Z.SAVED_DOB_STATE,
    default: ""
});


/***/ }),

/***/ 63224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ productItemState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41562);
/* harmony import */ var src_constants_graph_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98373);





var query = "\n".concat(src_constants_graph_queries__WEBPACK_IMPORTED_MODULE_3__/* .stripeProductFragment */ .M, "\nquery stripeProduct($input: StripeProductFilterV2) {\n  viewer {\n    user {\n      stripeProducts(input: $input) {\n        ...FStripeProduct\n      }\n    }\n  }\n}");
var productItemState = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .selectorFamily */ .CG)({
    key: "productItemState",
    get: function(id) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1, viewer;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return graphql_react_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"].request */ .Z.request(query, {
                            input: {
                                id: id
                            }
                        });
                    case 3:
                        viewer = _ctx.sent.viewer;
                        return _ctx.abrupt("return", (viewer === null || viewer === void 0 ? void 0 : (ref = viewer.user) === null || ref === void 0 ? void 0 : (ref1 = ref.stripeProducts) === null || ref1 === void 0 ? void 0 : ref1[0]) || null);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    }
});


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* reexport safe */ _orderByCondition__WEBPACK_IMPORTED_MODULE_0__.b; }
/* harmony export */ });
/* harmony import */ var _orderByCondition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3247);





/***/ }),

/***/ 3247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SectionType; }
/* harmony export */ });
var SectionType;
(function(SectionType) {
    SectionType["evaluationQuestions"] = "evaluation_questions";
    SectionType["DOBInput"] = "DOB_input";
    SectionType["medsSelection"] = "meds_selection";
    SectionType["productSelection"] = "product_selection";
    SectionType["treatmentSummary"] = "treatment_summary";
    SectionType["dosageSelection"] = "dosage_selection";
    SectionType["freqSelection"] = "freq_selection";
})(SectionType || (SectionType = {}));


/***/ }),

/***/ 28849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getEvaluationDataFromLocalStorage; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants_local_storage_names_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90047);


var getEvaluationDataFromLocalStorage = function(evaluationId) {
    var localEval = localStorage.getItem((0,src_constants_local_storage_names_constant__WEBPACK_IMPORTED_MODULE_1__/* .evaluationLSName */ .u5)(evaluationId));
    if (localEval) {
        var currentLocalEval = JSON.parse(localEval);
        var isDone = currentLocalEval === null || currentLocalEval === void 0 ? void 0 : currentLocalEval.done;
        var evaluationSysId = currentLocalEval === null || currentLocalEval === void 0 ? void 0 : currentLocalEval.evaluationSysId;
        var consultType = currentLocalEval === null || currentLocalEval === void 0 ? void 0 : currentLocalEval.consultType;
        var latestQuestionSysId = currentLocalEval === null || currentLocalEval === void 0 ? void 0 : currentLocalEval.latestQuestionSysId;
        var evaluationData = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatten)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.values)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.omit)([
            "done",
            "evaluationSysId",
            "latestQuestionSysId",
            "consultType"
        ], currentLocalEval)));
        var patientQAndA = evaluationData === null || evaluationData === void 0 ? void 0 : evaluationData.map(function(param) {
            var question = param.question, answer = param.answer, value = param.value;
            return {
                questionAnswer: {
                    question: question,
                    answer: answer
                },
                value: value === null || value === void 0 ? void 0 : value.toString()
            };
        });
        return {
            evaluationData: evaluationData,
            isDone: isDone,
            evaluationSysId: evaluationSysId,
            consultType: consultType,
            latestQuestionSysId: latestQuestionSysId,
            patientQAndA: patientQAndA
        };
    }
    return {
        isDone: false
    };
};


/***/ }),

/***/ 64025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ isPatientRole; },
/* harmony export */   "tY": function() { return /* binding */ isAdminRole; },
/* harmony export */   "xY": function() { return /* binding */ isDoctorRole; }
/* harmony export */ });
/* unused harmony export isTestRole */
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12705);

var isDoctorRole = function(role) {
    return role === graphql_generated__WEBPACK_IMPORTED_MODULE_0__.UserRole.Doctor || role === graphql_generated__WEBPACK_IMPORTED_MODULE_0__.UserRole.TestDoctor;
};
var isPatientRole = function(role) {
    return role === graphql_generated__WEBPACK_IMPORTED_MODULE_0__.UserRole.Patient || role === graphql_generated__WEBPACK_IMPORTED_MODULE_0__.UserRole.TestPatient;
};
var isAdminRole = function(role) {
    return role === graphql_generated__WEBPACK_IMPORTED_MODULE_0__.UserRole.Admin;
};
var isTestRole = function(role) {
    return role === UserRole.TestDoctor || role === UserRole.TestPatient;
};


/***/ }),

/***/ 86229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ getTracking; },
/* harmony export */   "NK": function() { return /* binding */ clearUtm; },
/* harmony export */   "PB": function() { return /* binding */ getUtm; },
/* harmony export */   "Vv": function() { return /* binding */ getTrackingFromQueryString; },
/* harmony export */   "Wi": function() { return /* binding */ setUtm; },
/* harmony export */   "bh": function() { return /* binding */ getBrowserPlatform; },
/* harmony export */   "vg": function() { return /* binding */ setTracking; }
/* harmony export */ });
/* unused harmony export buildTraits */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82954);
/* harmony import */ var src_constants_Countries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73252);








function cleanObject(obj) {
    Object.keys(obj).forEach(function(key) {
        // Remove key if the value is null or undefined
        if (obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        } else if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            // If the value is an object, call cleanObject recursively
            obj[key] = cleanObject(obj[key]);
            // If the recursive call returns an empty object, delete the key
            if (Object.keys(obj[key]).length === 0) {
                delete obj[key];
            }
        }
    // Note: This does not handle arrays or Date objects or other complex objects properly
    });
    return obj;
}
var traitSchema = yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().email().required(),
    createdAt: yup__WEBPACK_IMPORTED_MODULE_3__/* .date */ .hT().required(),
    firstName: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_(),
    lastName: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_(),
    name: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_(),
    phone: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_(),
    address: yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({}),
    birthday: yup__WEBPACK_IMPORTED_MODULE_3__/* .date */ .hT(),
    id: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required()
});
var buildTraits = function(user, patient, utm) {
    var traits = _object_spread({
        email: user.email,
        createdAt: (patient === null || patient === void 0 ? void 0 : patient.createdAt) || "",
        firstName: (patient === null || patient === void 0 ? void 0 : patient.firstName) || "",
        lastName: (patient === null || patient === void 0 ? void 0 : patient.lastName) || "",
        name: (patient === null || patient === void 0 ? void 0 : patient.fullName) || "",
        phone: (patient === null || patient === void 0 ? void 0 : patient.phoneNumber) || "",
        platform: (patient === null || patient === void 0 ? void 0 : patient.fromPlatformEnv) || "",
        region: CURRENT_COUNTRY,
        address: (patient === null || patient === void 0 ? void 0 : patient.deliveryAddress) ? pick(patient === null || patient === void 0 ? void 0 : patient.deliveryAddress, [
            "country",
            "state",
            "postal",
            "phoneNumber",
            "unit",
            "city",
            "region",
            "address"
        ]) : null,
        birthday: (patient === null || patient === void 0 ? void 0 : patient.dob) ? new Date(patient === null || patient === void 0 ? void 0 : patient.dob) : null,
        id: user.id
    }, utm || getUtm());
    cleanObject(traits);
    if (traits.address) {
        cleanObject(traits.address);
        traits.address.region = traits.address.region || "sg";
    }
    try {
        traitSchema.validateSync(traits, {
            abortEarly: false
        });
    } catch (error) {
        console.error(error);
        var msg = "Invalid traits: ".concat(JSON.stringify(traits));
        throw new Error(msg);
    }
    return traits;
};
var getUtm = function() {
    var utmVars = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id"
    ];
    return utmVars.reduce(function(acc, utmVar) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.camelCase)(utmVar), getTrackingFromQueryString(utmVar) || getTrackingFromCookie(utmVar) || getTrackingFromLocalStorage(utmVar)));
    }, {});
};
var clearUtm = function() {
    var utmVars = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id"
    ];
    utmVars.forEach(function(utmVar) {
        try {
            // clear cookie
            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove((0,lodash__WEBPACK_IMPORTED_MODULE_1__.snakeCase)(utmVar));
            // clear localStorage
            localStorage.removeItem((0,lodash__WEBPACK_IMPORTED_MODULE_1__.snakeCase)(utmVar));
        } catch (e) {
            console.error("Clearing utm issue");
        }
    });
};
var getTracking = function() {
    return {
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        sourceTracking: getTrackingByKey("source_tracking"),
        fbc: getTrackingByKey("fbc") || getTrackingByKey("_fbc"),
        fbp: getTrackingByKey("fbp") || getTrackingByKey("_fbp"),
        gclid: getTrackingByKey("gclid"),
        host: window.location.host,
        path: window.location.pathname
    };
};
var setUtm = function() {
    var utm = getUtm();
    Object.keys(utm).forEach(function(key) {
        if (utm[key]) {
            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set((0,lodash__WEBPACK_IMPORTED_MODULE_1__.snakeCase)(key), utm[key], {
                expires: 30
            });
        // localStorage.setItem(snakeCase(key), utm[key]);
        }
    });
};
var setTracking = function() {
    var tracking = getTracking();
    Object.keys(tracking).forEach(function(key) {
        if (tracking[key]) {
            localStorage.setItem((0,lodash__WEBPACK_IMPORTED_MODULE_1__.snakeCase)(key), tracking[key]);
        }
    });
};
var getTrackingByKey = function(key) {
    return getTrackingFromQueryString(key) || getTrackingFromCookie(key) || getTrackingFromLocalStorage(key) || null;
};
var getTrackingFromQueryString = function(key) {
    try {
        var ref, ref1, ref2, ref3;
        return ((ref3 = (ref2 = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.search) === null || ref1 === void 0 ? void 0 : ref1.split("".concat(key, "="))[1]) === null || ref2 === void 0 ? void 0 : ref2.split("&")) === null || ref3 === void 0 ? void 0 : ref3[0]) || null;
    } catch (e) {
        console.error("Tracking from query string issue");
        return null;
    }
};
var getBrowserPlatform = function() {
    var userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|ipod/i.test(userAgent)) {
        return "Mobile";
    }
    return "Web";
};
var getTrackingFromLocalStorage = function(key) {
    return localStorage.getItem(key);
};
var getTrackingFromCookie = function(key) {
    try {
        var ref, ref1, ref2;
        return ((ref2 = (ref1 = document === null || document === void 0 ? void 0 : (ref = document.cookie) === null || ref === void 0 ? void 0 : ref.split("".concat(key, "="))[1]) === null || ref1 === void 0 ? void 0 : ref1.split(";")) === null || ref2 === void 0 ? void 0 : ref2[0]) || null;
    } catch (e) {
        console.error("Tracking from cookie issue");
        return null;
    }
};


/***/ })

}]);